import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hizmetler from "../pages/hizmetler/page";
import HizmetBolgeleri from "../pages/hizmet-bolgeleri/page";
import Iletisim from "../pages/iletisim/page";
import Hakkimizda from "../pages/hakkimizda/page";
import BolgeLandingPage from "../pages/landing/BolgeLandingPage";
import MahalleLandingPage from "../pages/landing/MahalleLandingPage";
import HizmetLandingPage from "../pages/landing/HizmetLandingPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <Hizmetler />,
  },
  {
    path: "/hizmet-bolgeleri",
    element: <HizmetBolgeleri />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "/hakkimizda",
    element: <Hakkimizda />,
  },
  // Hizmet landing pages: /hizmetler/acil-kapi-acma, etc.
  {
    path: "/hizmetler/:hizmetSlug",
    element: <HizmetLandingPage />,
  },
  // Bölge landing pages: /beylikduzu-cilingir, /esenyurt-cilingir, etc.
  {
    path: "/:bolgeSlug",
    element: <BolgeLandingPage />,
  },
  // Mahalle landing pages: /beylikduzu-cilingir/adnan-kahveci, etc.
  {
    path: "/:bolgeSlug/:mahalleSlug",
    element: <MahalleLandingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
